import { SxProps } from '@mui/material';
import theme, { globalSectionPadding } from '@theme/index';

const { palette, spacing } = theme;

const styles: Record<string, SxProps> = {
  root: {
    padding: globalSectionPadding,
    backgroundColor: palette.primary['400'],
    overflowX: 'clip',
    minHeight: {
      xs: '78rem',
      sm: '97rem',
      md: '95rem',
      lg: '100vh'
    }
  },
  heading: {
    color: palette.primary.main
  },

  borrowSectionImage: {
    display: {
      xs: 'none',
      md: 'flex'
    },
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    paddingTop: '66.64%',
    height: 0,
    width: '100%'
  },

  headingText: {
    mt: spacing(1)
  },

  calculatorWrapper: {
    width: { md: '43rem', xs: '100%' }
  },

  gridItemLeft: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: { xs: 'flex-start', sm: 'center' },
    position: 'absolute',
    top: {
      xs: '28.5rem',
      sm: '47.5rem',
      md: '37.5rem',
      lg: '0'
    },
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: '1'
  },

  imageContainer: {
    display: 'block',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    img: {
      width: '100%',
      height: { xs: '100%', lg: '100%' },
      objectFit: { xs: 'contain', sm: 'contain', md: 'contain', lg: 'contain' },
      transform: {
        xs: 'translate(1rem, -8rem)',
        sm: 'translate(1rem, 4rem)',
        md: 'translate(12rem, -1rem)',
        lg: 'translate(22rem, 4rem)',
        xl: 'translate(33%, 4rem)'
      }
    }
  }
};

export default styles;
